<template>
    <base-spinner :open="isloading"></base-spinner>
    <div class="site__body">
            <div class="block-header block-header--has-breadcrumb block-header--has-title">
                <div class="container">
                    <div class="faq__header">
                        <h1 class="faq__header-title">Contact Us</h1>
                    </div>
                </div>
            </div>
            <div class="block">
                <div class="container container--max--lg">
                    <div class="card contacts">
                        <div class="contacts__map" v-html="gmapcontent">
                            
                        </div>
                        <!-- <iframe src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1402904.3596968907!2d-78.40039815619949!3d35.24419438006126!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89ae80ee5f60f7c3%3A0x4f6a75a38e66bbd5!2sDMS%20Systems!5e0!3m2!1sen!2sus!4v1604424014590!5m2!1sen!2sus;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed' frameborder='0' scrolling='no' marginheight='0' marginwidth='0'></iframe> -->
                        <div class="card-body card-body--padding--2">
                            <div class="row">
                                <div class="col-12 col-lg-6 pb-4 pb-lg-0">
                                    <div class="mr-1">
                                        <div v-html="content" v-if="content != '' && !isloading"></div>
                                        <div class="text-center mt-4 mb-4" v-else-if="content === '' && !isloading">
                                            Content Unavailable.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <div class="ml-1">
                                        <div v-html="col2content">
                                        </div>
                                        <!-- <h4 class="contact-us__header card-title">Leave us a Message</h4> -->
                                        <form>
                                            <!-- <base-message
                                                v-if="!isloading"
                                                :servermessages="servermessages"
                                            ></base-message> -->
                                            <div class="col-12 col-md-12 p-0" v-if="servermessages.length > 0">
                                                <div class="alert alert-danger mb-3">
                                                    <!-- <strong>Please correct all of the errors listed below before proceding. <br/></strong> -->
                                                    <strong v-for="message in servermessages" :key="message">
                                                        {{ message }} <br/>
                                                    </strong> 
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6 has-icon" :class="{ invalid: nameValid === 'invalid' }">
                                                    <label for="form-name">Your Name</label>
                                                    <input type="text" id="form-name" class="form-control" placeholder="Your Name" v-model.trim="name" @blur="validateName">
                                                    <small class="invalid-text" v-if="nameValid === 'invalid'">
                                                        <i>Please enter your name.</i>  
                                                    </small>
                                                </div>
                                                <div class="form-group col-md-6 has-icon" :class="{ invalid: emailValid === 'invalid' }">
                                                    <label for="form-email">Email</label>
                                                    <input type="email" id="form-email" class="form-control" placeholder="Email Address" v-model.trim="email" @blur="validateEmail">
                                                    <small class="invalid-text" v-if="emailValid === 'invalid'">
                                                        <i>Please enter a valid email address.</i>  
                                                    </small>
                                                </div>
                                            </div>
                                            <div class="form-group has-icon" :class="{ invalid: subjectValid === 'invalid' }">
                                                <label for="form-subject">Subject</label>
                                                <input type="text" id="form-subject" class="form-control" placeholder="Subject" v-model.trim="subject" @blur="validateSubject">
                                                <small class="invalid-text" v-if="subjectValid === 'invalid'">
                                                    <i>Please enter a subject.</i>  
                                                </small>
                                            </div>
                                            <div class="form-group has-icon" :class="{ invalid: messageValid === 'invalid' }">
                                                <label for="form-message">Message</label>
                                                <textarea id="form-message" class="form-control" rows="4" v-model.trim="message" @blur="validateMessage"></textarea>
                                                <small class="invalid-text" v-if="messageValid === 'invalid'">
                                                    <i>Please enter a message.</i>  
                                                </small>
                                            </div>
                                            <button type="button" class="btn btn-primary mt-3" @click="sendMessage">Send Message</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block-space block-space--layout--before-footer"></div>
        </div>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";

export default {
    data () {
        return {
            name: '',
            email: '',
            subject: '',
            message: '',
            nameValid: 'pending',
            emailValid: 'pending',
            subjectValid: 'pending',
            messageValid: 'pending',
            content: '',
            gmapcontent: '',
            col2content: '',
            isloading: false,
            servermessages: []
        }
    },
    methods: {
        validateName() {
            if (this.name === "") {
                this.nameValid = "invalid";
            } else {
                this.nameValid = "valid";
            }
        },
        validateEmail() {
            if (this.email === "") {
                this.emailValid = "invalid";
            } else {
                if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.email)) {
                    this.emailValid = "valid";
                } else {
                    this.emailValid = "invalid";
                }
            }
        },
        validateSubject() {
            if (this.subject === "") {
                this.subjectValid = "invalid";
            } else {
                this.subjectValid = "valid";
            }
        },
        validateMessage() {
            if (this.message === "") {
                this.messageValid = "invalid";
            } else {
                this.messageValid = "valid";
            }
        },
        sendMessage() {
            this.isloading = true;
            this.servermessages = [];

            axiosvl.post(this.$store.getters['api/contact_us_uri'], {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            // "HOSTURL": { "value": this.$store.getters.hosturl },
                            "LW3SFID": { "value": this.$store.getters.storefront },
                            "LW3CHNAME": { "value": this.name },
                            "LW3CEMAIL": { "value": this.email },
                            "LW3EMLDES": { "value": this.subject },
                            "LW3CNTSTR": { "value": this.message }
                        }
                    }
                }
            )
            .then((response) => {
                this.isloading = false;

                // const fields = response.data.webroutine.fields;
                // this.content = fields.LW3CNTSTR.value;

                const messages = [];
                const wrmessages = response.data.webroutine.messages;

                if (wrmessages != undefined) {
                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }
                    this.servermessages = messages;
                }

            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log(error);
            });
        },
        getContent() {
            this.isloading = true;
            this.content = '';
            this.servermessages = [];

            // "/d15pgmlib/lansaweb?w=CESGETCNT&r=usGetSinglePageCont&vlweb=1&part=CML&lang=ENG&_T=20210114"
            axiosvl.post(this.$store.getters['api/content_contact_us_uri'], {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            LW3SFID: {
                                value: this.$store.getters.storefront,
                            },
                            "LW3PAGSDC": {
                                "value": 'CONTACTUS'
                            },
                            "LW3PAGLSD": {
                                "value": 'MAIN'
                            }
                        }
                    }
                }
            )
            .then((response) => {
                this.isloading = false;

                const fields = response.data.webroutine.fields;
                this.content = fields.LW3CNTSTR.value;

                const messages = [];
                const wrmessages = response.data.webroutine.messages;

                if (wrmessages != undefined) {
                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }
                    this.servermessages = messages;
                }

            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log(error);
            });
        },
        getTopContent() {
            this.isloading = true;
            this.gmapcontent = '';
            this.servermessages = [];

            // "/d15pgmlib/lansaweb?w=CESGETCNT&r=usGetSinglePageCont&vlweb=1&part=CML&lang=ENG&_T=20210114"
            axiosvl.post(this.$store.getters['api/content_contact_us_uri'], {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            LW3SFID: {
                                value: this.$store.getters.storefront,
                            },
                            "LW3PAGSDC": {
                                "value": 'CONTACTUS'
                            },
                            "LW3PAGLSD": {
                                "value": 'Google Map'
                            }
                        }
                    }
                }
            )
            .then((response) => {
                this.isloading = false;

                const fields = response.data.webroutine.fields;
                this.gmapcontent = fields.LW3CNTSTR.value;

                const messages = [];
                const wrmessages = response.data.webroutine.messages;

                if (wrmessages != undefined) {
                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }
                    this.servermessages = messages;
                }

            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log(error);
            });
        },

        getCol2Content() {
            this.isloading = true;
            this.col2content = '';
            this.servermessages = [];

            // "/d15pgmlib/lansaweb?w=CESGETCNT&r=usGetSinglePageCont&vlweb=1&part=CML&lang=ENG&_T=20210114"
            axiosvl.post(this.$store.getters['api/content_contact_us_uri'], {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            LW3SFID: {
                                value: this.$store.getters.storefront,
                            },
                            "LW3PAGSDC": {
                                "value": 'CONTACTUS'
                            },
                            "LW3PAGLSD": {
                                "value": 'COL2-Header'
                            }
                        }
                    }
                }
            )
            .then((response) => {
                this.isloading = false;

                const fields = response.data.webroutine.fields;
                this.col2content = fields.LW3CNTSTR.value;

                const messages = [];
                const wrmessages = response.data.webroutine.messages;

                if (wrmessages != undefined) {
                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }
                    this.servermessages = messages;
                }

            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log(error);
            });
        },
        
    },
    mounted() {
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
        this.name = '', this.email = '', this.subject = '', this.message = '';
        this.nameValid = 'pending', this.emailValid = 'pending', this.subjectValid = 'pending', this.messageValid = 'pending';

        let tmout = 500;
        if (this.$store.getters.storefront == ''){
            tmout = 2000;
        }

        setTimeout(() => {
            this.getContent();
            this.getTopContent();
            this.getCol2Content();
        }, tmout);
    }
}
</script>

<style scoped>
.form-group.has-icon {
    position: relative;
}

.form-group.invalid input,
.form-group.invalid textarea,
.form-group.invalid label {
    border-color: #cb1818;
}

.form-group.invalid label,
.form-group.invalid .invalid-text {
    color: #cb1818;
}
</style>